import { Column } from "@components/Layout";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import { userContext } from "@layouts/App/context/User";
import { useLocation } from "@solidjs/router";
import { BsEyeglasses } from "solid-icons/bs";
import { FaRegularBookmark, FaSolidArrowRightToBracket, FaSolidUser } from "solid-icons/fa";
import { IoHomeOutline, IoMicOutline } from "solid-icons/io";
import { OcPeople3, OcPerson3 } from "solid-icons/oc";
import { type VoidComponent, useContext } from "solid-js";
import { Show } from "solid-js";
import { z } from "zod";
import MenuItem from "../MenuItem";
import Player from "./components/Player";
import UserRow from "./components/UserRow";
import { CloseButton, NavItemsColumn, NavbarWrapper } from "./styled";

const Navbar: VoidComponent<{ open: boolean; onClose: () => void; public?: boolean }> = (props) => {
	const { user } = useContext(userContext);
	const { t } = useI18n();
	const location = useLocation();

	const uuid = () => {
		for (const i of location.pathname.split("/")) if (z.string().uuid().safeParse(i).success) return i;
		return undefined;
	};

	return (
		<NavbarWrapper
			transition={{ duration: 0.3 }}
			animate={{
				right: props.open ? 0 : "100dvw",
			}}
		>
			<CloseButton onclick={props.onClose} font-size="35px" />
			<Column onclick={props.onClose} h="100%" justifyContent="space-between" gap="10px">
				<Column>
					<Show when={!props.public}>
						<UserRow />
					</Show>
					<NavItemsColumn>
						<Show
							when={props.public}
							fallback={
								<>
									<MenuItem href="/home" icon={<IoHomeOutline size={30} />} w="100%">
										{t("app.nav.home")}
									</MenuItem>
									<MenuItem href="/create" icon={<IoMicOutline size={30} />} w="100%">
										{t("app.create.header")}
									</MenuItem>
									<MenuItem href={`/profile/${user.uid}`} icon={<OcPerson3 size={25} />} w="100%">
										{t("app.nav.myProgrammes")}
									</MenuItem>
									<MenuItem href="/discover/*" icon={<BsEyeglasses size={30} />} w="100%">
										{t("app.discover.header")}
									</MenuItem>
									<MenuItem href="/groups" icon={<OcPeople3 size={25} />} w="100%">
										{t("app.groups.header")}
									</MenuItem>
									<MenuItem href="/bookmarks/*" icon={<FaRegularBookmark size={25} />} w="100%">
										{t("app.nav.bookmarks")}
									</MenuItem>
								</>
							}
						>
							<MenuItem
								href="/auth/login"
								icon={<FaSolidArrowRightToBracket size={25} />}
								w="100%"
								state={{
									trackListUUID: uuid(),
								}}
							>
								{t("auth.login.header")}
							</MenuItem>
							<MenuItem
								href="/auth/register"
								icon={<FaSolidUser size={25} />}
								w="100%"
								state={{
									trackListUUID: uuid(),
								}}
							>
								{t("auth.register.header")}
							</MenuItem>
						</Show>
					</NavItemsColumn>
				</Column>
				<Player />
			</Column>
		</NavbarWrapper>
	);
};
export default Navbar;
